import { TOfferCard } from '../types/offer';

type TOfferProps = Pick<TOfferCard, 'phones'>;

export function getOfferPhone(offer: TOfferProps) {
  const phone = offer.phones?.[0];

  return phone && phone.number
    ? `${phone.countryCode && phone.countryCode.startsWith('+') ? '' : '+'}${phone.countryCode}${phone.number}`
    : '';
}

export function formatOfferPhone(phone: string) {
  return phone ? `${phone.startsWith('+') ? '' : '+'}${phone}` : '';
}
